import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaTrashAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import AddRoom from "./AddRoom";
import EditRoom from "./EditRoom";
import ConfigurationList from "./ConfigurationList";
import { formatDate } from "../../utils/date";

const RoomList = () => {
  const [rooms, setRooms] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null);
  const [configRoom, setConfigRoom] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchRooms = async () => {
    try {
      const res = await axios.get(`${API_URL}/ems/rooms`);
      if (Array.isArray(res.data)) setRooms(res.data);
    } catch (err) {
      console.error("Failed to fetch rooms", err);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this room?")) return;
    try {
      await axios.delete(`${API_URL}/ems/rooms/${id}`);
      setRooms((prev) => prev.filter((room) => room._id !== id));
    } catch (err) {
      alert("Delete failed");
    }
  };

  return (
    <div>
      <button
        onClick={() => setShowAddModal(true)}
        style={{
          float: "right",
          marginBottom: "20px",
          background: "black",
          color: "white",
          padding: "5px 10px",
          borderRadius: "5px",
        }}
      >
        + Add Room
      </button>

      <h2>Room Management</h2>

      {rooms.length === 0 && <p>No rooms available</p>}

      {rooms.map((room, index) => (
        <div
          key={room._id}
          style={{
            backgroundColor: index % 2 === 0 ? "#E3F5EC" : "#FFF4DB",
            padding: "15px",
            marginBottom: "10px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderLeft: index % 2 === 0 ? "5px solid #064c38" : "5px solid #D9A128",
          }}
        >
          <div>
            <p><strong>Hotel ID(s):</strong> {Array.isArray(room.hotel_id) ? room.hotel_id.join(", ") : room.hotel_id}</p>
            <p><strong>Room Type:</strong> {room.room_type}</p>
            <p><strong>Price:</strong> ${room.price}</p>
            <p><strong>No of Rooms:</strong> {room.no_of_rooms}</p>
            <p><strong>From:</strong> {formatDate(room.from_date)}</p>
            <p><strong>To:</strong> {formatDate(room.to_date)}</p>
          </div>

          <div style={{ display: "flex", gap: "8px" }}>
            <button
              onClick={() => setConfigRoom(room)}
              style={{
                color: "#000",
                background: "transparent",
                borderColor: "#000",
                fontSize: "11px",
                padding: "3px 8px",
              }}
              className="btn btn-sm"
            >
              Configurations
            </button>

            <button
              onClick={() => setEditingRoom(room)}
              style={{
                color: "#000",
                background: "transparent",
                borderColor: "#000",
              }}
            >
              <FontAwesomeIcon icon={faPen} />
            </button>

            <button
              onClick={() => handleDelete(room._id)}
              style={{
                color: "#000",
                background: "transparent",
                borderColor: "#000",
              }}
            >
              <FaTrashAlt size={15} />
            </button>
          </div>
        </div>
      ))}

      {showAddModal && (
        <AddRoom
          onAdded={() => { setShowAddModal(false); fetchRooms(); }}
          onClose={() => setShowAddModal(false)}
        />
      )}

      {editingRoom && (
        <EditRoom
          room={editingRoom}
          onUpdated={() => { setEditingRoom(null); fetchRooms(); }}
          onClose={() => setEditingRoom(null)}
        />
      )}

      {configRoom && (
        <ConfigurationList
          room={configRoom}
          onClose={() => setConfigRoom(null)}
        />
      )}
    </div>
  );
};

export default RoomList;
